const isNode = typeof process !== 'undefined' && process.versions?.node;
const isBrowser = typeof window !== 'undefined';

// Lazy loading for Node.js modules
let fs: any, path: any;

async function getNodeModules() {
    if (isNode && !fs) {
        const fsModule = await import('fs');
        const pathModule = await import('path');
        fs = fsModule.default;
        path = pathModule.default;
    }
    return { fs, path };
}

interface GenerateDeeplinkOptions {
    serverName?: string;
    projectDir?: string;
}

function generateDeeplink(options: GenerateDeeplinkOptions = {}) {
    const { serverName = '@appkit4-dev/rapidcraft-mcp', projectDir = '<project_dir>' } = options;

    // Append @latest if a version is not explicitly provided (handles scoped packages)
    const atCount = (serverName.match(/@/g) || []).length;
    const versionedServerName = atCount >= 2 ? serverName : `${serverName}@latest`;

    const config = {
        command: 'npx',
        args: [
            '-y',
            '--registry',
            'https://artifacts-west.pwc.com/artifactory/api/npm/g00020-pwc-gx-digital-appkit-npm/',
            versionedServerName,
        ],
        env: {
            RAPIDCRAFT_PROJECT_DIR: projectDir,
            NPM_CONFIG_REGISTRY: 'https://artifacts-west.pwc.com/artifactory/api/npm/g00020-pwc-gx-digital-appkit-npm/',
        },
    };

    const configString = JSON.stringify(config);
    const base64Config = isNode ? Buffer.from(configString).toString('base64') : btoa(configString);
    const deeplink = `cursor://anysphere.cursor-deeplink/mcp/install?name=${encodeURIComponent(serverName)}&config=${base64Config}`;

    return { config, base64Config, deeplink };
}

async function runCLI() {
    if (!isNode) throw new Error('CLI mode only available in Node.js');

    const { fs, path } = await getNodeModules();

    const args = process.argv.slice(2);
    const serverNameArg = args.find((arg) => arg.startsWith('--server='));
    const projectDirArg = args.find((arg) => arg.startsWith('--project-dir='));

    const serverName = serverNameArg?.split('=')[1] || '@appkit4-dev/rapidcraft-mcp';
    const projectDir = projectDirArg?.split('=')[1] || path.join(process.env.HOME, 'rapidcraft-projects');

    const result = generateDeeplink({ serverName, projectDir });

    console.log('RapidCraft MCP Deeplink Generator\n');
    console.log(`Server: ${serverName}`);
    console.log(`Project Dir: ${projectDir}\n`);
    console.log('Deeplink URL:');
    console.log(result.deeplink);

    try {
        fs.writeFileSync('deeplink.txt', result.deeplink);
        console.log('\nSaved to: deeplink.txt');
    } catch {
        console.log('\nCould not save to file');
    }

    console.log('\nUsage:');
    console.log('  node generate-deeplink.js --server=my-server --project-dir=/custom/path');

    return result;
}

if (isNode && import.meta.url === `file://${process.argv[1]}`) {
    runCLI().catch(console.error);
}

// Export for both environments
export { generateDeeplink, runCLI };

// Browser global assignment
if (isBrowser && typeof window !== 'undefined') {
    (window as any).generateDeeplink = generateDeeplink;
}
